import styled, { css } from "styled-components";
import { deviceMax } from "../../../utils/device";

interface IIconBox {
  accent: string;
}

export const StepWrapper = styled.article(
  ({ theme }) => css`
    background: ${theme.colors.brand.soft};
    border-radius: ${theme.layout.radius.card};
    padding: 28px 28px 30px;
    position: relative;

    @media ${deviceMax.desktopSMax} {
      padding: 25px;
    }

    @media ${deviceMax.tabletWideMax} {
      padding: 23px;
    }

    @media ${deviceMax.phoneMax} {
      padding: 24px;
    }
  `
);

export const StepTop = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;

  @media ${deviceMax.tabletWideMax} {
    margin-bottom: 24px;
  }

  @media ${deviceMax.phoneMax} {
    margin-bottom: 20px;
  }
`;

export const StepNumber = styled.span(
  ({ theme }) => css`
    color: #748197;
    font-size: 11px;
    font-weight: ${theme.typography.weights.bold};
    letter-spacing: 0.12em;
    text-transform: uppercase;
  `
);

export const IconBox = styled.span<IIconBox>(
  ({ theme, accent }) => css`
    align-items: center;
    background: ${theme.colors.white};
    border-radius: 10px;
    color: ${accent};
    display: flex;
    height: 44px;
    justify-content: center;
    width: 44px;

    @media ${deviceMax.phoneMax} {
      height: 38px;
      width: 38px;
    }
  `
);

export const StepTitle = styled.h3(
  ({ theme }) => css`
    font-family: ${theme.typography.fonts.display};
    font-size: 22px;
    font-weight: 650;
    letter-spacing: -0.035em;
    line-height: 1.08;
    margin: 0 0 14px;

    @media ${deviceMax.tabletWideMax} {
      font-size: 19px;
    }

    @media ${deviceMax.phoneMax} {
      font-size: 22px;
      margin-bottom: 12px;
    }
  `
);

export const StepDescription = styled.p`
  color: ${({ theme }) => theme.colors.brand.muted};
  font-size: 14px;
  line-height: 1.7;
  margin: 0;

  @media ${deviceMax.tabletWideMax} {
    font-size: 12px;
  }

  @media ${deviceMax.phoneMax} {
    font-size: 14px;
    max-width: 450px;
  }
`;
